module.exports = __webpack_public_path__ + "static/media/nft-market-place.4a3fae38.png";